module.exports = __webpack_public_path__ + "static/media/Panel-Planet-Card.098f82d6.svg";